import TreeNodeMixin from './TreeNodeMixin';
import ShortcutsMixin from './ShortcutsMixin';
import UtilsKnowledgeMixin from './UtilsKnowledgeMixin';

export default {
  mixins: [TreeNodeMixin, ShortcutsMixin, UtilsKnowledgeMixin],
};
